import { PartyTypes, AuctionStatuses } from 'vdlib';

const RoleStatusPartsColumnsDefs = {
  [`${PartyTypes.Operator}_${AuctionStatuses.Pending}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Ενεργοποίηση',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.Active}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Προσφορές',
    'Υπ. Χρόνος',
    'Ρυθμίσεις',
  ],
  [`${PartyTypes.Operator}_${AuctionStatuses.ForSelection}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Προσφορές',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.ForAcceptance}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.ForDispatch}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.DispatchProblem}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.Finished}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.Pending}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Ενεργοποίηση',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.Active}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Προσφορές',
    'Υπ. Χρόνος',
    'Ρυθμίσεις',
  ],
  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.ForSelection}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Προσφορές',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.ForAcceptance}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.ForDispatch}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.DispatchProblem}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.Finished}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.Active}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Αρχ.Τιμή',
    'Υπ. Χρόνος',
    'Λεπτομέρειες',
    // 'selection',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.Pending}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.ForSelection}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Clickable Προσφορές',
    'Αρχ.Τιμή',
    'Best',
    'Selected',
    'Επιλογή',
    // 'selection',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.ForAcceptance}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Αρχ.Τιμή',
    'Αποδεχθείσα Προσφορά',
    'Λεπτομέρειες',
    // 'selection',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.ForDispatch}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Αρχ.Τιμή',
    'Αποδεχθείσα Προσφορά',
    'Λεπτομέρειες',
    // 'selection',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.DispatchProblem}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Αρχ.Τιμή',
    'Αποδεχθείσα Προσφορά',
    'Λεπτομέρειες',
    // 'selection',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.Finished}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Αρχ.Τιμή',
    'Αποδεχθείσα Προσφορά',
    'Λεπτομέρειες',
    // 'selection',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.Active}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Υπ. Χρόνος',
    'Clickable Προσφορές',
    'Προσφορά',
  ],

  [`${PartyTypes.Merchant}_Participate`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Υπ. Χρόνος',
    'Clickable Προσφορές',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.ForAcceptance}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Προσφορά Εμπόρου',
    'Αποδοχή',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.ForDispatch}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Παράδοση',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.DispatchProblem}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Παράδοση',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.Finished}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Expert}_${AuctionStatuses.Finished}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Λεπτομέρειες',
  ],

  [`${PartyTypes.Expert}_${AuctionStatuses.Active}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Προσφορές',
    'Υπ. Χρόνος',
  ],

  [`${PartyTypes.Expert}_${AuctionStatuses.Pending}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Ενεργοποίηση',
  ],

  [`${PartyTypes.Expert}_${AuctionStatuses.ForSelection}`]: [
    'ID',
    'PartNumber',
    'PartDescription',
    'Προσφορές',
    'Λεπτομέρειες',
    // 'selection',
  ],
};

export default RoleStatusPartsColumnsDefs;
